import { View } from 'foundations-components/components/View';
import { ButtonGroup } from 'foundations-components/transitional/components/ButtonGroup';
import { jsx as _jsx } from "react/jsx-runtime";
const ZoomableButtonGroup = props => {
  const {
    isMinimized,
    children,
    marginInlineEnd
  } = props;
  return /*#__PURE__*/_jsx(View, {
    display: "inline-block",
    boxShadow: isMinimized ? undefined : '300',
    marginInlineEnd: marginInlineEnd,
    children: /*#__PURE__*/_jsx(ButtonGroup, {
      children: children
    })
  });
};
export default ZoomableButtonGroup;